/**
 * 設定 → データの取込（#268 1.5c-1、docs/98 §6・docs/68 §1）。管理者だけ。iOS 風（docs/10 §9.15）。
 *   「請求書（未入金）取込」「取引先取込」（#288。PC だけ＝PC_ONLY_FEATURES の dataImport）と取込の履歴（スマホでも見る）。行を押すと取込の画面（確認の続き・完了・取消）
 */
import { IMPORT_KIND_LABEL, IMPORT_MSG as M, IMPORT_SOURCE_LABEL, IMPORT_STATUS_LABEL, type ImportList } from "@genbaryoku/contract";
import { useQuery } from "@tanstack/react-query";
import { api, messageOf } from "../api.js";
import { useBackNav, usePageName } from "../components/BackButton.jsx";
import { GroupList, GroupNavRow, GroupSection, GroupTextRow } from "../components/GroupList.jsx";
import { SettingsHead, useRestPageClass } from "../components/SettingsHead.jsx";
import { ErrorText, Help } from "../components/ui.jsx";
import { usePcOnly } from "../lib/pcOnly.js";

export const IMPORTS_KEY = ["imports"] as const;

const jstDay = (iso: string): string => {
  const d = new Date(new Date(iso).getTime() + 9 * 3600 * 1000);
  return `${d.getUTCMonth() + 1}/${d.getUTCDate()}`;
};

export function SettingsImportsPage() {
  const q = useQuery({ queryKey: IMPORTS_KEY, queryFn: () => api<ImportList>("GET", "/imports") });
  const back = useBackNav({ to: "/settings", label: "設定" }, false);
  usePageName(M.title);
  const cls = useRestPageClass("importspage");
  const pcOnly = usePcOnly();
  return (
    <div className={cls} data-testid="imports-settings">
      <SettingsHead back={back} title={M.title} />
      {pcOnly.hidden("/imports/new") ? null : (
        <GroupSection help={<Help testId="help-imports" label={M.title} text={M.help} />} data-testid="imports-new-sec">
          <GroupList>
            <GroupNavRow title={M.newUnpaid} to="/imports/new" buttonId="toImportNew" testId="imports-new" />
            <GroupNavRow title={M.newPartners} to="/imports/new?kind=partners" buttonId="toImportNewPartners" testId="imports-new-partners" />
          </GroupList>
        </GroupSection>
      )}
      <GroupSection title={M.history} data-testid="imports-history">
        {q.isError ? <ErrorText>{messageOf(q.error)}</ErrorText> : null}
        <GroupList>
          {!q.data ? (
            <GroupTextRow>読み込んでいます…</GroupTextRow>
          ) : q.data.items.length === 0 ? (
            <GroupTextRow testId="imports-empty">{M.empty}</GroupTextRow>
          ) : (
            q.data.items.map((x) => (
              <GroupNavRow
                key={x.id}
                title={x.fileName}
                sub={`${jstDay(x.createdAt)}・${IMPORT_KIND_LABEL[x.kind]}・${IMPORT_SOURCE_LABEL[x.source]}${x.importedAt ? `・${x.imported}件` : ""}${x.undoable && x.undoUntil ? `・${M.undoUntil(jstDay(x.undoUntil))}` : ""}`}
                value={IMPORT_STATUS_LABEL[x.status]}
                to={`/imports/${x.id}`}
                testId={`imports-row-${x.id}`}
              />
            ))
          )}
        </GroupList>
      </GroupSection>
    </div>
  );
}
